import React from 'react';
import { Tooltip } from '@paypalcorp/pp-react';
import { getCdnHostName } from '@paypalcorp/instance-location';
import withTheme from '../../common/withTheme';

class Donationprogress extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			propertyInfo:this.props.propertyInfo,
			trackDonationInfo:this.props.trackDonationInfo,
		};
	}
	render() {
		let trackDonationInfo = this.state.trackDonationInfo,
			propertyInfo = this.state.propertyInfo,
			logo_url = (trackDonationInfo.charity_info && trackDonationInfo.charity_info.logo_url) ? trackDonationInfo.charity_info.logo_url : `https://${getCdnHostName()}/webstatic/ppgf/donationtracker/Placeholder_logo.svg`,
			logoBoxStyle = (trackDonationInfo.charity_info && trackDonationInfo.charity_info.logo_url) ?
				{
					"backgroundImage": `url(${logo_url})`,
					"backgroundPosition": "center center",
					"backgroundRepeat": "no-repeat",
					"backgroundSize": "contain"
				} :
				{
					"backgroundImage": `url(${logo_url})`,
					"backgroundPosition": "center center",
					"backgroundRepeat": "no-repeat"
				},
			opacity = (trackDonationInfo.payout_status == 3) ? "opacity" : "",
			delayedPopupContent = (
				<div>{propertyInfo.trackdonation.modalpara1}<br /><br />{propertyInfo.trackdonation.modalpara2}</div>
			),
			unEnrolledPopupContent = (
				<div>{propertyInfo.trackdonation.dpunenrolledtooltip}</div>
			),
			enrolledPopupContent = (
				<div>{propertyInfo.trackdonation.dpenrolledtooltip}</div>
			),
			payoutMode = (trackDonationInfo.payout_mode == "PAYPAL") ? propertyInfo.trackdonation.paidviapaypal : propertyInfo.trackdonation.checkmailtocharity,
			donation_source;
		// Display Donation Source for Unenrolled Charities
		if (trackDonationInfo.charity_info && trackDonationInfo.charity_info.charityCC) {
			const charityCC = trackDonationInfo.charity_info.charityCC;
			donation_source = propertyInfo.trackdonation.src[charityCC];
			}
    	
		return (
			<div id="donateprogress">
				<div className="">
					<div className="charityinfoBox">
						<div className="logoBox" style={logoBoxStyle}>
						</div>
						<div className="charityinfoBoxLeft hidden-xs">
							{trackDonationInfo.charity_info && trackDonationInfo.charity_info.name ?
								<div>
									<h1>{trackDonationInfo.charity_info.name}</h1>
									<p>{trackDonationInfo.charity_info.mission}</p>
								</div> : ''}
							<p>{propertyInfo.trackdonation.source}{(trackDonationInfo.charity_type == "UNENROLLED") ? <span className="unenrolled">{donation_source}</span> : <span className="enrolled">{propertyInfo.trackdonation.ppgfprofile}</span> }</p>
							<p className="Status-With-PayPal"> <span className="text-style">{propertyInfo.trackdonation.status}</span>
							{(trackDonationInfo.payout_status == 3)? <span className="delayed">{propertyInfo.trackdonation.delayeddelivery}<Tooltip name="delayed" description={delayedPopupContent} /></span>:(trackDonationInfo.payout_status == 4)?<span className="completed">{propertyInfo.trackdonation.senttocharity}</span> : <span className="underprocess">{propertyInfo.trackdonation.withppgf}</span> }</p>
						</div>
						<div className="charityinfoBoxRight hidden-xs">
							<p id="txnId">#{trackDonationInfo.transaction_id}</p>
						</div>
						<div className="charityinfoBoxRight visible-xs">
							<p className="Status-With-PayPal"> <span className="text-style">{propertyInfo.trackdonation.status}</span>
							{(trackDonationInfo.payout_status == 3)? <span className="delayed">{propertyInfo.trackdonation.delayeddelivery}<Tooltip name="delayed" description={delayedPopupContent} /></span>:(trackDonationInfo.payout_status == 4)?<span className="completed">{propertyInfo.trackdonation.senttocharity}</span> : <span className="underprocess">{propertyInfo.trackdonation.withppgf}</span> }</p>
							<p>#{trackDonationInfo.transaction_id}</p>
						</div>
						<div className="charityinfoBoxLeft visible-xs">
							{trackDonationInfo.charity_info && trackDonationInfo.charity_info.name ?
								<div>
									<h1>{trackDonationInfo.charity_info.name}</h1>
									<p>{trackDonationInfo.charity_info.mission}</p>
								</div>
								: ''}
							<p>{propertyInfo.trackdonation.source}{(trackDonationInfo.charity_type == "UNENROLLED") ? <span className="unenrolled">{donation_source}</span> : <span className="enrolled">{propertyInfo.trackdonation.ppgfprofile}</span> }</p>
						</div>
					</div>
					<div className="progressBarWrap hidden-xs">
						<div id="progress" className={opacity}>
						{(trackDonationInfo.payout_status == 1 || trackDonationInfo.payout_status == 2) ? <div className="progress-bar-half"></div> : ""}
						{trackDonationInfo.payout_status == 3 ? <div className="progress-bar-delayed"></div> : ""}
						{trackDonationInfo.payout_status == 4 ? <div className="progress-bar"></div> : ""}
						</div>
					</div>
					<div className="donationStatus hidden-xs">
						<div className="span4 pull-left">
							<p><strong>{propertyInfo.trackdonation.donationmade}</strong></p>
							<p>{trackDonationInfo.convertedtransactdate}</p>
						</div>
						<div className="span4 pull-left">
							<p className="text-center"><strong>{propertyInfo.trackdonation.develiverypending}</strong> {trackDonationInfo.charity_type == "UNENROLLED" ? <Tooltip name="unenrolled" description={unEnrolledPopupContent} /> : <Tooltip name="enrolled" description={enrolledPopupContent} />  } </p>
						</div>
						<div className="span pull-right">
							{trackDonationInfo.payout_status == 4 ? <p><strong>{payoutMode}</strong></p> : <p><strong>{propertyInfo.trackdonation.estimatedpayoutdate}</strong></p>}
							<p>{trackDonationInfo.convertedpytdate}</p>
						</div>
					</div>
					<div className="donationStatus visible-xs">
						<div className="progressBarWrap">
							<div id="progress" className={opacity}>
								{(trackDonationInfo.payout_status == 1 || trackDonationInfo.payout_status == 2) ? <div className="progress-bar-half"></div> : ""}
								{trackDonationInfo.payout_status == 3 ? <div className="progress-bar-delayed"></div> : ""}
								{trackDonationInfo.payout_status == 4 ? <div className="progress-bar"></div> : ""}
							</div>
							<div className="span4">
								<p><strong>{propertyInfo.trackdonation.donationmade}</strong></p>
								<p>{trackDonationInfo.convertedtransactdate}</p>
							</div>
							<div className="span4">
								<p><strong>{propertyInfo.trackdonation.develiverypending}</strong> {trackDonationInfo.charity_type == "UNENROLLED" ? <Tooltip name="unenrolled" description={unEnrolledPopupContent} /> : <Tooltip name="enrolled" description={enrolledPopupContent} /> }</p>
								<p>&nbsp;</p>
							</div>
							<div className="span4">
								{trackDonationInfo.payout_status == 4 ? <p><strong>{payoutMode}</strong></p> : <p><strong>{propertyInfo.trackdonation.estimatedpayoutdate}</strong></p>}
								<p>{trackDonationInfo.convertedpytdate}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);

	}
}
export default withTheme(Donationprogress);